import { useState } from 'react';
import './PlaybackControls.css';

export default function PlaybackControls({ 
  currentSpeed = 1, 
  onSpeedChange,
  speeds = [1, 2, 3, 4],
  className = ''
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div 
      className={`zibby-playback-controls ${className}`}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {isVisible && (
        <div className="zibby-speed-controls">
          {speeds.map(speed => (
            <button
              key={speed}
              className={currentSpeed === speed ? 'zibby-speed-active' : ''}
              onClick={() => onSpeedChange && onSpeedChange(speed)}
            >
              x{speed}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

